import { render, staticRenderFns } from "./EnterAmount.vue?vue&type=template&id=70779c83&scoped=true"
import script from "./EnterAmount.vue?vue&type=script&lang=js"
export * from "./EnterAmount.vue?vue&type=script&lang=js"
import style0 from "./EnterAmount.vue?vue&type=style&index=0&id=70779c83&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70779c83",
  null
  
)

export default component.exports